import type { MedalTier } from "@dailywars/core/medals";

import { MedalIcon } from "#/components/MedalIcon";
import { Skeleton } from "#/components/ui/skeleton";

const MEDAL_ORDER: readonly MedalTier[] = ["gold", "silver", "bronze"];

export function ProfileMedalsBadges({
  goldMedals,
  silverMedals,
  bronzeMedals,
}: {
  goldMedals: number;
  silverMedals: number;
  bronzeMedals: number;
}) {
  const counts: Record<MedalTier, number> = {
    gold: goldMedals,
    silver: silverMedals,
    bronze: bronzeMedals,
  };

  return (
    <div className="flex items-center gap-4">
      {MEDAL_ORDER.map((tier) => (
        <span
          key={tier}
          className="inline-flex items-center gap-1.5 text-base font-medium tabular-nums text-foreground"
        >
          <MedalIcon tier={tier} size={28} />
          <span>{counts[tier]}</span>
        </span>
      ))}
    </div>
  );
}

export function ProfileMedalsBadgesSkeleton() {
  return (
    <div className="flex items-center gap-4">
      {MEDAL_ORDER.map((tier) => (
        <Skeleton key={tier} className="h-7 w-14" />
      ))}
    </div>
  );
}
